import { cx } from '@linaria/core';
import { useRef } from 'react';
import { getCaptionValue } from '@pm2/content-engine';
import { ElementToolbar } from '@pm2/element-toolbar';
import { textColumnCls } from '@pm2/react-utils';
import { usePM2DisplayContext, pm2ConfigStore } from '@pm2/store';
import { headerText, heading, elementToolbar, header, container } from './_slider.style.js';
import { Caption } from './atom.caption.js';
import { Scrambled } from './atom.scrambled.js';
import { CarouselSlider } from './organism.carousel/_carousel.js';
import { SingularSlider, SliderComponentSelector } from './organism.slider/_slider.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function SliderComponent(props) {
  const containerRef = useRef(null);
  const {
    inLightbox
  } = usePM2DisplayContext();
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  if (props.pm2.isScrambled) {
    return /*#__PURE__*/jsx(Scrambled, {});
  }
  if (props.slides.length === 0) {
    // unable to render completely empty slides; they don't really make any
    // sense either so assume that they work
    return null;
  }
  const displayCaption = props.options.displayCaption || inLightbox;
  const content = (() => {
    switch (props.options.displayType) {
      case "carousel":
        return /*#__PURE__*/jsx(CarouselSlider, {
          ...props,
          displayCaption: displayCaption
        });
      default:
        return /*#__PURE__*/jsx(SingularSlider, {
          ...props,
          displayCaption: displayCaption
        });
    }
  })();
  return /*#__PURE__*/jsxs("section", {
    ref: containerRef,
    className: cx("gSlider", container),
    "data-audience": audience,
    "data-lightbox": inLightbox,
    "data-component-type": SliderComponentSelector,
    children: [/*#__PURE__*/jsxs("header", {
      className: cx(header, textColumnCls),
      children: [/*#__PURE__*/jsxs("div", {
        className: headerText,
        children: [props.options.displayTitle && /*#__PURE__*/jsx("h4", {
          className: heading,
          children: getCaptionValue(props.meta.caption.title)
        }), displayCaption && /*#__PURE__*/jsx(Caption, {
          caption: props.meta.caption,
          inLightbox: inLightbox
        })]
      }), /*#__PURE__*/jsx("div", {
        className: elementToolbar,
        children: /*#__PURE__*/jsx(ElementToolbar, {
          node: props,
          customPosition: true
        })
      })]
    }), content]
  });
}

export { SliderComponent };
//# sourceMappingURL=_slider.js.map
